import { render, staticRenderFns } from "./editPolicy.vue?vue&type=template&id=5c9439a3"
import script from "./editPolicy.vue?vue&type=script&lang=js"
export * from "./editPolicy.vue?vue&type=script&lang=js"
import style0 from "./editPolicy.vue?vue&type=style&index=0&id=5c9439a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports